var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var LoginService = /** @class */ (function (_super) {
    __extends(LoginService, _super);
    function LoginService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 通过角色Id获取所有资源信息
     * @param data 查询参数实体
     */
    LoginService.prototype.getAllResourcesByRoleId = function (data) {
        return this.netService.send({
            server: managementService.loginController.getAllResourcesByRoleId,
            data: {
                // 用户拥有的角色列表
                roleIds: data.roleIds,
                // 用户名-登录名
                userName: data.userName,
                //
                realName: data.realName,
                // 用户Id
                userId: data.userId,
                // token
                token: data.token,
                // 公司编码
                companyCode: data.companyCode,
                // 机构id
                deptId: data.deptId,
                //
                hashCode: data.hashCode
            }
        });
    };
    /**
     * 通过userToken获取用户信息
     * @param userToken  登陆token
     */
    LoginService.prototype.getUserByToken = function (userToken) {
        return this.netService.send({
            server: managementService.loginController.getUserByToken,
            data: {
                // 用户token
                userToken: userToken
            }
        });
    };
    /**
     * 用户登录
     * @param data 登陆参数实体
     */
    LoginService.prototype.login = function (data) {
        return this.netService.send({
            server: managementService.loginController.login,
            data: {
                password: data.password,
                userName: data.userName
            },
            loading: true
        });
    };
    /**
     * 更新用户密码
     * @param data 用户实体
     */
    LoginService.prototype.updatePassword = function (data) {
        return this.netService.send({
            server: managementService.loginController.updatePassword,
            data: {
                newPassword: data.newPassword,
                oldPassword: data.oldPassword
            },
            loading: true
        });
    };
    __decorate([
        Inject(NetService)
    ], LoginService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], LoginService.prototype, "login", null);
    __decorate([
        Debounce()
    ], LoginService.prototype, "updatePassword", null);
    return LoginService;
}(Service));
export { LoginService };
